module.exports = __webpack_public_path__ + "static/media/admin_add-user.8f24b5ef.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/admin_add-user.md
// module id = 1081
// module chunks = 0